import { comics } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function LatestUpdates() {
  const latest = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="mx-auto px-4 md:px-6">
        <div className="mb-8">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            实时追更
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            最新上架漫画
          </h2>
          <p className="text-sm text-foreground-500 mt-1">追更列表实时刷新</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              data-product-shop=""
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫大全`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {comic.title}
                    </h3>
                  </div>
                  <p className="text-xs text-foreground-500">
                    {comic.author} · 更新至第{comic.updateChapter}话 · {comic.rating}分
                  </p>
                </div>
                <p className="text-sm text-foreground-600 line-clamp-2 mt-2 leading-relaxed">
                  &ldquo;{comic.description}&rdquo;
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <span className={`px-2 py-0.5 rounded-full text-xs ${
                    comic.status === '连载中'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {comic.status}
                  </span>
                  <span className="text-xs text-foreground-400">{comic.updatedAt}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}